/**
 @author xiaoye
 @date 2020/4/28 10:01 下午
 */

//图例
export const comLegend = function (config, data, type) {

    let top = null, bottom = null, left = null, right = null;
    if (config.position === 'top') {
        top = '3%';
        left = 'center';
    } else if (config.position === 'bottom') {
        left = 'center';
        bottom = '3%';
    } else if (config.position === 'left') {
        top = 'center';
        left = '1%';
    } else if (config.position === 'right') {
        top = 'center';
        right = '1%';
    }else if (config.position === 'leftTop') {
        top = '3%';
        left = 'left';
    } else if (config.position === 'leftBottom') {
        left = 'left';
        bottom = '3%';
    } else if (config.position === 'rightTop') {
        top = '3%';
        right = 'right';
    } else if (config.position === 'rightBottom') {
        bottom = '3%';
        right = 'right';
    }
    return {
        data: data,
        show: config.show,
        orient: config.orient,
        right: right,
        left: left,
        bottom: bottom,
        top: top,
        itemGap: parseInt(config.marInterval),
        pageTextStyle: {
            color: config.font.size,
        },
        textStyle: {
            color: config.font.color,
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: config.font.size,
        },
        type: 'scroll'
    }
};


// let colorList = {
//     0: ["rgba(43, 175, 165, 1)", "rgba(153, 218, 172, 1)", "rgba(216, 240, 216, 1)", "rgba(153, 222, 248, 1)", "rgba(178, 228, 216, 1)", "rgba(101, 202, 186, 1)", "rgba(45, 178, 196, 1)", "rgba(9, 146, 169, 1)", "rgba(4, 104, 157, 1)", "rgba(15, 125, 163, 1)", "rgba(141, 198, 237, 1)", "rgba(176, 223, 234, 1)"],
//     1: ["rgba(229, 231, 86, 1)", "rgba(223, 223, 1, 1)", "rgba(182, 210, 1, 1)", "rgba(130, 150, 0, 1)", "rgba(86, 124, 3, 1)", "rgba(125, 171, 23, 1)", "rgba(88, 181, 48, 1)", "rgba(144, 199, 97, 1)", "rgba(87, 186, 139, 1)", "rgba(2, 168, 106, 1)", "rgba(3, 146, 92, 1)", "rgba(0, 120, 74, 1)"],
//     2: ["rgba(255, 235, 149, 1)", "rgba(254, 226, 80, 1)", "rgba(180, 153, 0, 1)", "rgba(158, 127, 0, 1)", "rgba(154, 105, 0, 1)", "rgba(217, 165, 1, 1)", "rgba(249, 190, 0, 1)", "rgba(251, 206, 77, 1)", "rgba(247, 178, 74, 1)", "rgba(242, 153, 1, 1)", "rgba(210, 131, 0, 1)", "rgba(170, 90, 3, 1)"],
//     3: ["rgba(190, 157, 237, 1)", "rgba(117, 185, 242, 1)", "rgba(247, 186, 115, 1)", "rgba(253, 126, 180, 1)", "rgba(88, 224, 232, 1)", "rgba(247, 115, 124, 1)", "rgba(186, 215, 134, 1)", "rgba(247, 208, 115, 1)", "rgba(190, 157, 237, 1)", "rgba(117, 185, 242, 1)", "rgba(247, 186, 115, 1)", "rgba(253, 126, 180, 1)"],
//     4: ["rgba(13, 176, 162, 1)", "rgba(249, 134, 102, 1)", "rgba(116, 194, 88, 1)", "rgba(172, 143, 238, 1)", "rgba(87, 147, 211, 1)", "rgba(246, 185, 90, 1)", "rgba(255, 125, 151, 1)", "rgba(137, 179, 194, 1)", "rgba(20, 204, 188, 1)", "rgba(249, 134, 102, 1)", "rgba(21, 178, 204, 1)", "rgba(172, 143, 238, 1)"],
//     5: ["rgba(243, 188, 9, 1)", "rgba(34, 159, 255, 1)", "rgba(240, 141, 29, 1)", "rgba(57, 174, 78, 1)", "rgba(223, 49, 132, 1)", "rgba(0, 174, 165, 1)", "rgba(127, 160, 230, 1)", "rgba(234, 96, 96, 1)", "rgba(243, 188, 9, 1)", "rgba(34, 159, 255, 1)", "rgba(240, 141, 29, 1)", "rgba(57, 174, 78, 1)"],
//     6: ["rgba(236, 97, 78, 1)", "rgba(243, 148, 68, 1)", "rgba(247, 178, 74, 1)", "rgba(254, 216, 79, 1)", "rgba(229, 231, 86, 1)", "rgba(177, 210, 95, 1)", "rgba(90, 187, 136, 1)", "rgba(28, 153, 199, 1)", "rgba(111, 89, 164, 1)", "rgba(150, 84, 158, 1)", "rgba(217, 95, 120, 1)", "rgba(242, 120, 100, 1)"],
//     7: ["rgba(237, 87, 54, 1)", "rgba(68, 206, 246, 1)", "rgba(255, 164, 0, 1)", "rgba(27, 209, 165, 1)", "rgba(160, 97, 209, 1)", "rgba(101, 129, 229, 1)", "rgba(158, 217, 0, 1)", "rgba(221, 156, 71, 1)", "rgba(244, 81, 94, 1)", "rgba(233, 187, 29, 1)", "rgba(123, 207, 166, 1)", "rgba(54, 159, 201, 1)"],
//     8: ["rgba(92, 163, 219, 1)", "rgba(81, 196, 193, 1)", "rgba(229, 93, 142, 1)", "rgba(147, 110, 187, 1)", "rgba(249, 178, 74, 1)", "rgba(131, 189, 86, 1)", "rgba(175, 164, 152, 1)", "rgba(226, 126, 75, 1)", "rgba(108, 193, 148, 1)", "rgba(206, 122, 198, 1)", "rgba(234, 106, 106, 1)", "rgba(125, 142, 201, 1)"],
//     9: ["rgba(244, 77, 77, 1)", "rgba(243, 143, 0, 1)", "rgba(226, 202, 26, 1)", "rgba(93, 200, 0, 1)", "rgba(24, 133, 232, 1)", "rgba(110, 110, 249, 1)", "rgba(163, 73, 234, 1)", "rgba(224, 70, 126, 1)", "rgba(247, 99, 99, 1)", "rgba(244, 97, 39, 1)", "rgba(242, 200, 17, 1)", "rgba(42, 170, 209, 1)"],
//     10: ["rgba(94, 105, 109, 1)", "rgba(83, 189, 189, 1)", "rgba(54, 153, 184, 1)", "rgba(165, 106, 157, 1)", "rgba(255, 149, 102, 1)", "rgba(150, 198, 107, 1)", "rgba(241, 200, 14, 1)", "rgba(254, 99, 95, 1)", "rgba(249, 178, 74, 1)", "rgba(0, 187, 167, 1)", "rgba(254, 171, 137, 1)", "rgba(92, 106, 122, 1)"],
//     11: ["rgba(119, 184, 74, 1)", "rgba(231, 179, 9, 1)", "rgba(227, 97, 44, 1)", "rgba(57, 137, 201, 1)", "rgba(154, 118, 160, 1)", "rgba(189, 159, 82, 1)", "rgba(90, 106, 212, 1)", "rgba(0, 166, 188, 1)", "rgba(57, 187, 122, 1)", "rgba(197, 97, 187, 1)", "rgba(221, 88, 88, 1)", "rgba(82, 163, 163, 1)"],
//     12: ["rgba(119, 184, 74, 1)", "rgba(231, 179, 9, 1)", "rgba(227, 97, 44, 1)", "rgba(57, 137, 201, 1)", "rgba(154, 118, 160, 1)", "rgba(189, 159, 82, 1)", "rgba(90, 106, 212, 1)", "rgba(0, 166, 188, 1)", "rgba(57, 187, 122, 1)", "rgba(197, 97, 187, 1)", "rgba(221, 88, 88, 1)", "rgba(82, 163, 163, 1)"],
// };
//颜色
export const colorList = {
    '对比色': ['#0263ca', '#03ddff', '#60acfc', '#23c2db', '#63d5b2', '#d4ec59', '#feb64d', '#fa816d', '#fe834d', '#d15b7f'],
    '冷色系': ['#0118a5', '#014ea5', '#017ca5', '#019fa5', '#2ad9e0', '#01a565', '#2ee970', '#707070', '#b5b5b5', '#ffffff'],
    '清新色系': ['#668ed6', '#60acfc', '#23c2db', '#32d3eb', '#9cdc82', '#d4ec59', '#ffe168', '#ffc168', '#ff9a68', '#ff6868'],
    '暖色': ['#7079df', '#d15b7f', '#fb6e6c', '#ff9f69', '#feb64d', '#ffe168', '#9c70df', '#c670df', '#df70b7', '#df7080'],
    '荧光色': ['#05fbf8', '#05fbad', '#fafd02', '#fe0303', '#fe4e00', '#fead00', '#05b3fb', '#05fb56', '#fd04f4', '#ffffff'],
    '红黑色': ['#000000', '#a40000', '#fe0303', '#f39800', '#f3d900', '#05fbf8', '#05b8fb', '#626262', '#959595', '#ffffff',],
    '莫兰迪色': ['#5b9fbf', '#5bbfa2', '#5bbf67', '#7abf5b', '#a6bf5b', '#bfab5b', '#e1aa52', '#d3a589', '#d69085', '#d98d8d'],
    '碰撞色': ['#313131', '#eb6100', '#8957a1', '#f3d900', '#017cfd', '#fd006b', '#00fd83', '#6d03fe', '#fd0202', '#2400fc'],
    '糖果色': ['#248ce1', '#29b457', '#e2a248', '#6c78a0', '#946dc0', '#16babb', '#5854ab', '#e4667b', '#ea8446', '#73c928'],
    '雾蓝色': ['#00b7ee', '#556fb5', '#8957a1', '#13b5b1', '#ec6941', '#959595', '#02fef8', '#4e7dfc', '#81d6d4','#d15b7f'],
};

//颜色方法
export const comColor = function (index) {
    let count = 0;
    let label = '';
    for (let i in colorList) {
        if (count === index) {
            label = i;
        }
        count++;
    }
    if (label) {
        return colorList[label]
    } else {
        return colorList['对比色']
    }
};
// 3d地图信息板开关
var infoWin;
var tableDom;
export const openInfoWin = function (map, event, content) {
    if (!infoWin) {
        infoWin = new AMap.InfoWindow({
            autoMove:false,
            isCustom: true,  //使用自定义窗体
            offset: new AMap.Pixel(130, 100)
        });
    }

    var x = event.offsetX;
    var y = event.offsetY;
    var lngLat = map.containerToLngLat(new AMap.Pixel(x, y));

    if (!tableDom) {
        let infoDom = document.createElement('div');
        infoDom.className = 'mapinfo';
        tableDom = document.createElement('table');
        infoDom.appendChild(tableDom);
        infoWin.setContent(infoDom);
    }
    var trStr = '';
    for (var name in content) {
        var val = content[name];
        trStr +=
            '<tr>' +
            '<td class="label" >' + name + '</td>' +
            '<td>&nbsp;</td>' +
            '<td class="content">' + val + '</td>' +
            '</tr>'
    }

    tableDom.innerHTML = trStr;
    infoWin.open(map, lngLat);
}

export const closeInfoWin = function closeInfoWin() {
    if (infoWin) {
        infoWin.close();
    }
}
